import { all, call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import Cookies from "js-cookie";
import { BASE_URL } from "../../shared/constants";
import {
  loginStart,
  loginSuccess,
  loginError,
  signUpStart,
  signUpSuccess,
  signUpError,
  logOut,
  verifyStart,
  verifySuccess,
  verifyError,
  forgotStart,
  forgotSuccess,
  forgotError,
  resetStart,
  resetSuccess,
  resetError,
} from "./reducer";
import { structureError } from "../../shared/error";

function* login({ payload }) {
  try {
    const { data } = yield axios.post(`${BASE_URL}/users/login`, payload);
    // console.log(data)
    Cookies.set(
      "@DAS_AUTH",
      JSON.stringify({
        token: data.accessToken,
        user: data.user,
        routing: data.specialRouting,
      }),
      {
        expires: 90,
      }
    );
    yield put(
      loginSuccess({
        token: data.accessToken,
        user: data.user,
        routing: data.specialRouting,
      })
    );
  } catch (error) {
    yield put(
      loginError({
        error: structureError(error),
      })
    );
  }
}

function* signUp({ payload }) {
  try {
    yield axios.post(`${BASE_URL}/users/register`, payload);

    yield put(signUpSuccess());
  } catch (error) {
    yield put(
      signUpError({
        error: structureError(error),
      })
    );
  }
}


function* verify({ payload }) {
  // console.log("it is hre", payload)
  try {
    yield axios.post(`${BASE_URL}/users/verify-user`, payload);

    yield put(verifySuccess());
  } catch (error) {
    yield put(
      verifyError({
        error: structureError(error),
      })
    );
  }
}
function* forgot({ payload }) {
  // console.log("it is hre", payload)
  try {
    yield axios.post(`${BASE_URL}/users/forgot-password`, payload);

    yield put(forgotSuccess());
  } catch (error) {
    yield put(
      forgotError({
        error: structureError(error),
      })
    );
  }
}

function* resetPassword({ payload }) {
  // console.log("it is hre", payload)
  try {
    yield axios.post(`${BASE_URL}/users/reset-password`, payload);

    yield put(resetSuccess());
  } catch (error) {
    yield put(
      resetError({
        error: structureError(error),
      })
    );
  }
}
function* logout() {
  Cookies.remove("@DAS_AUTH");
}

function* onLogin() {
  yield takeLatest(loginStart.type, login);
}

function* onSignUp() {
  yield takeLatest(signUpStart.type, signUp);
}

function* onLogOut() {
  yield takeLatest(logOut.type, logout);
}
function* onVerify() {
  yield takeLatest(verifyStart.type, verify);
}
function* onForgot() {
  yield takeLatest(forgotStart.type, forgot);
}
function* onReset() {
  yield takeLatest(resetStart.type, resetPassword);
}

function* authSagas() {
  yield all([call(onLogin), call(onSignUp), call(onLogOut), call(onVerify), call(onForgot), call(onReset)]);
}


export default authSagas;
